import { DocumentData } from "@1games-ru/region-shared/dist/types/documents/documentData";
import clsx from "clsx";

export default function VehicleRegistrationCertificate({
  docNumber,
  issuedAt,
  owner,
}: DocumentData) {
  return (
    <div
      className={clsx(
        "flex flex-col w-[30.625rem] h-[37.75rem] bg-[#C3D4DE]",
        "text-dark-800 p-[1.875rem] rounded-[0.4rem] overflow-clip",
      )}
      style={{
        backgroundImage: "url(./svg/documents/vehicle-passport.webp)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div className="text-[#175D83] text-16 font-medium">ВЫПИСКА</div>
      <div className="text-15 mt-0.5">из электронного паспорта транспортного средства</div>
      <div className="text-15 font-medium mt-2.5">№ {docNumber}</div>
      <div className="text-16 mt-5 flex flex-col gap-1.5">
        <div>
          статус <span className="font-medium">- завершенный</span>
        </div>
        <div>
          дата оформления <span className="font-medium">- {issuedAt}</span>
        </div>
        <div>
          владелец{" "}
          <span className="font-medium">- {[owner.lastName, owner.firstName].join(" ")}</span>
        </div>
      </div>
      <div
        className={clsx(
          "relative flex flex-col gap-5 mt-7.5 bg-[#E0E9F0]/60 p-5",
          "text-15 font-medium",
        )}
      >
        <div className="flex items-end justify-between">
          <div className="text-[#175D83]">
            Идентификационный <br />
            номер (VIN):
          </div>
          <div className="uppercase">-</div>
        </div>
        <div className="flex items-end justify-between">
          <div className="text-[#175D83]">Марка модель:</div>
          <div className="uppercase">-</div>
        </div>
        <div className="flex items-end justify-between">
          <div className="text-[#175D83]">Год выпуска:</div>
          <div className="uppercase">-</div>
        </div>
        <div className="flex items-end justify-between">
          <div className="text-[#175D83]">Категория ТС:</div>
          <div className="uppercase">-</div>
        </div>
        <div className="flex items-end justify-between">
          <div className="text-[#175D83]">Цвет кузова:</div>
          <div className="uppercase">-</div>
        </div>
        <div className="flex items-end justify-between">
          <div className="text-[#175D83]">Двигатель (тип топлива):</div>
          <div className="uppercase">-</div>
        </div>
        <img
          src="./svg/documents/seal-epts-service.webp"
          alt=""
          className="z-1 absolute -bottom-[3.125rem] right-[5rem] w-[6.25rem] aspect-square pointer-events-none"
        />
      </div>
      <div className="flex flex-col items-center gap-1 mt-auto">
        <div className="text-[#175D83] font-medium text-15">
          Cистема Электронных Паспортов Региона
        </div>
        <div className="text-dark-800/80 text-14">
          * Сведения, содержащиеся в выписке, являются актуальными
        </div>
      </div>
    </div>
  );
}
